/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-03-07 14:08:40
 * @LastEditTime: 2025-04-24 09:18:04
 */
import React, { useState, useEffect} from "react";
import { setApplyCount } from '@/features/user/userSlice';
import { Input, Select, Pagination, message } from 'antd';
import ServiceTableMain from "./components/service-table";
import { afterSalesList } from '@/api/after-sales';
import { orderCountTotal } from '@/api/personal-center';
import NoData from '@/components/no-data';
import useBackToTop from '@/hooks/useBackToTop';
import { dispatch } from "@/redux/store";
import searchImg from '../assets/search.png';
import './index.scss';
interface pageType {
  pageNum: number,
  pageSize: number,
  orderNo?: string,
  status?: number
}
const AfterService: React.FC = () => {
  const { scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const [searchValue, setSearchValue] = useState(''); // 搜索框内容
  const [serviceData, setserviceData] = useState([]);
  const [pageNum, setPageNum] = useState(1); // 表格页码
  const [pageSize, setPageSize] = useState(10); // 表格页长
  const [isRefresh, setIsRefresh] = useState(false); // 更新列表
  const [serviceType, setServiceType] = useState(-1); // 售后状态
  const [total, setTotal] = useState<number>();
  const serviceList = [
    {
      name: '商品',
      width: 532
    },
    {
      name: '申请售后数量',
      width: 143
    },
    {
      name: '售后状态',
      width: 133,
      list: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 0,
          label: '售后处理'
        },
        {
          value: 1,
          label: '售后完成'
        },
        {
          value: 2,
          label: '已取消'
        },
      ]
    },
    {
      name: '操作',
      width: 103
    }
  ]
  useEffect(() => {
    scrollToTop();
    serviceListFunc();
  },[serviceType,pageNum])

  useEffect(() => {
    if(isRefresh) {
      serviceListFunc();
    }
  },[isRefresh])
  
  useEffect(() => {
    cartCountFunc();
  },[])

  // 更新数量
  const cartCountFunc = () => {
    orderCountTotal().then((oRes:any) => {
      if(oRes.success) {
        dispatch(setApplyCount(oRes.obj?.apply??0));
      }
    })
  }
  const orderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  // 搜索
  const orderSearch = () => {
    serviceListFunc()
  }
  const handleChangePagination = (page: number, pageSize: number) => {
    setPageNum(page);
    setPageSize(pageSize);
    scrollToTop();
  };
  // 获取售后申请列表
  const serviceListFunc = () => {
    setserviceData([]);
    const params:pageType = {pageNum,pageSize};
    if(searchValue !== '') {
      params.orderNo = searchValue;
    }
    if(serviceType !== -1) {
      params.status = serviceType;
    }
    afterSalesList(params).then((gRes:any) => {
      if(gRes.success) {
        setserviceData(gRes.obj?.list);
        setTotal(gRes.obj?.total);
        if(pageNum>0 && gRes.obj?.list?.length === 0 && gRes.obj?.total > 0) {
          setPageNum(pageNum-1);
        }
      }else {
        message.error(gRes.message);
      }
    })
  }
  // 售后状态切换
  const serviceStatusFunc = (value:number) => {
    setPageNum(1);
    setServiceType(value);
  }

  return (
    <div className="after-service-list">
      <div className="order-head">
        售后服务
        <div className="search-input">
          <Input placeholder="订单号" onChange={orderChange} onPressEnter={orderSearch} />
          <span onClick={()=>orderSearch()}><img src={searchImg} alt='' /></span>
        </div>
      </div>
      <div className="line"><i></i></div>
      <div className="order-list-content">
        <div className="list-header">
          {
            serviceList.map((tData,index) => (
              <div key={index} style={{width: tData.width}} className="list-header-title">
                {
                  tData.list ?
                  <Select
                    style={{ width: tData.width }}
                    placeholder={tData.name}
                    onChange={serviceStatusFunc}
                    options={tData.list}
                    getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                  />:
                  <>{tData.name}</>
                }
              </div>
            ))
          }
        </div>
        {
          serviceData.length > 0?
          <>
            <ServiceTableMain orderData={serviceData} setIsRefresh={setIsRefresh} />
              <div className="page-bottom">
                <Pagination
                  current={pageNum}
                  pageSize={pageSize}
                  total={total}
                  onChange={(page, pageSize) =>
                    handleChangePagination(page, pageSize)
                  }
                  showQuickJumper
                  showSizeChanger={false}
                />
              </div>
            </>
          :
          <NoData title='暂无数据' />
        }
      </div>
    </div>
  )
}

export default AfterService;